import React, { useState, useEffect } from "react";
import { Modal, TextField, Select } from "@mui/material";
import {
  useUpdateUserData,
  useUserData,
} from "components/customHooks/userDataContext";

import { displayDateFormatter } from "components/helpers";
import { getScribeList, getStatusList } from "apiHandler/actions";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { DATE_FORMAT } from "utils/helper";

const AdvanceSearchDictation = ({ onClose, onSearch }) => {
  const userData = useUserData();
  const setUserData = useUpdateUserData();
  const status_list = userData?.status_list || [];
  const scribe_list = userData?.scribe_list || [];
  const [loading, setLoading] = useState(false);

  // Input states
  const [patient_name, setPatient_name] = useState("");
  const [dob, setDob] = useState(null);
  const [dos_from, setDosFrom] = useState(null);
  const [dos_to, setDosTo] = useState(null);
  const [dictation_id, setDictation_id] = useState("");
  const [useDosRange, setUseDosRange] = useState(false);
  const [dos, setDos] = useState(null);
  // const [status, setStatus] = useState("");
  const [scribe_id, setScribe_id] = useState("");
  const token = userData?.access_token;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      patient_name: patient_name || undefined,
      dob: displayDateFormatter(dob) || undefined,
      ...(useDosRange
        ? {
            dos_from: dos_from ? displayDateFormatter(dos_from) : undefined,
            dos_to: dos_to ? displayDateFormatter(dos_to) : undefined,
          }
        : {
            dos: dos ? displayDateFormatter(dos) : undefined,
          }),
      dictation_id: dictation_id || undefined,
      // status: status || undefined,
    };

    onSearch(payload);
    setLoading(false);
    onClose();
  };

  useEffect(() => {
    const payload = {
      type: "Scribe",
      search_criteria: {
        practice_id: userData?.selected_practice,
      },
    };
    const fetchStatusList = async () => {
      const response = await getStatusList(payload, token);
      if (response) setUserData({ status_list: response });
    };
    const fetchScribeList = async () => {
      const response = await getScribeList(payload, token);
      if (response) setUserData({ scribe_list: response });
    };

    if (scribe_list?.length === 0) fetchScribeList();
    if (status_list?.length === 0) fetchStatusList();
  }, []);

  return (
    <Modal open={true} onClose={() => {}}>
      <form className="add-appointment-modal">
        <h1>Advance Search</h1>

        <div className="input-div">
          <div className="label"> Patient Name</div>
          <div className="input">
            <TextField
              value={patient_name}
              onChange={(e) => setPatient_name(e.target.value)}
              size="small"
              variant="standard"
            />
          </div>
        </div>
        <div className="input-div">
          <div className="label">Date Of Birth</div>
          <div className="input">
            <DesktopDatePicker
              value={dayjs(dob)}
              slotProps={{ textField: { variant: "standard" } }}
              onChange={(e) => setDob(e)}
              format={DATE_FORMAT}
              placeholder={DATE_FORMAT}
              maxDate={dayjs()}
            />
          </div>
        </div>
        <div className="input-div">
          <div className="label">Date Range</div>
          <div className="input">
            <input
              type="checkbox"
              checked={useDosRange}
              onChange={(e) => setUseDosRange(e.target.checked)}
            />
            <span style={{ marginLeft: 8 }}>Search by DOS range</span>
          </div>
        </div>
        {useDosRange ? (
          <>
            <div className="input-div">
              <div className="label">Date Of Service From</div>
              <div className="input">
                <DesktopDatePicker
                  value={dos_from}
                  slotProps={{ textField: { variant: "standard" } }}
                  onChange={(e) => setDosFrom(e)}
                  format={DATE_FORMAT}
                  maxDate={dayjs()}
                />
              </div>
            </div>

            <div className="input-div">
              <div className="label">Date Of Service To</div>
              <div className="input">
                <DesktopDatePicker
                  value={dos_to}
                  slotProps={{ textField: { variant: "standard" } }}
                  onChange={(e) => setDosTo(e)}
                  format={DATE_FORMAT}
                  maxDate={dayjs()}
                  minDate={dos_from || undefined}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="input-div">
            <div className="label">Date Of Service</div>
            <div className="input">
              <DesktopDatePicker
                value={dos}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={(e) => setDos(e)}
                format={DATE_FORMAT}
                maxDate={dayjs()}
              />
            </div>
          </div>
        )}
        <div className="input-div">
          <div className="label">Dictation Id</div>
          <div className="input">
            <TextField
              value={dictation_id}
              onChange={(e) => setDictation_id(e.target.value)}
              size="small"
              variant="standard"
            />
          </div>
        </div>

        {/* <div className="input-div">
          <div className="label">Status</div>
          <div className="input">
            <Select
              native
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              size="small"
              variant="standard"
            >
              <option value=""></option>
              {status_list.map((s) => (
                <option
                  key={s.status}
                  value={s.status}
                  className="text-capitalize"
                >
                  {s.status.toLowerCase()}
                </option>
              ))}
            </Select>
          </div>
        </div> */}
        <div className="input-div">
          <div className="label">Scribe</div>
          <div className="input">
            <Select
              native
              value={scribe_id}
              onChange={(e) => setScribe_id(e.target.value)}
              size="small"
              variant="standard"
            >
              <option value=""></option>
              {scribe_list.map((s) => (
                <option
                  key={s.value}
                  value={s.value}
                  className="text-capitalize"
                >
                  {s.first_name.toLowerCase()} {s.last_name.toLowerCase()}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className="btn-cont">
          <button type="submit" onClick={onSubmit} className="save">
            Search
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              if (loading) return;
              onClose();
            }}
            className="cancel"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AdvanceSearchDictation;
